import { render, staticRenderFns } from "./previewOfDepositAndWithdrawal.vue?vue&type=template&id=7fb9869d&scoped=true&"
import script from "./previewOfDepositAndWithdrawal.vue?vue&type=script&lang=js&"
export * from "./previewOfDepositAndWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./previewOfDepositAndWithdrawal.vue?vue&type=style&index=0&id=7fb9869d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb9869d",
  null
  
)

export default component.exports